export const HIDE_CLUSTER_NODE_SUCCESS = "HIDE_CLUSTER_NODE_SUCCESS";
export const HIDE_CLUSTER_NODE_REQUEST = "HIDE_CLUSTER_NODE_REQUEST";
export const HIDE_CLUSTER_NODE_FAILURE = "HIDE_CLUSTER_NODE_FAILURE";
